import React, { forwardRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SFTypesOfLoanComponent from "./component";

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = () => ({});

const ConnectedTypesOfLoan = connect(
    mapStateToProps,
    mapDispatchToProps
)(SFTypesOfLoanComponent);

export default forwardRef((props, ref) => (
    <ConnectedTypesOfLoan {...props} forwardedRef={ref} />
));
